// extracted by mini-css-extract-plugin
export default {"logo":"header-title_logo__4BiHw","root":"header-title_root__dNbBh","title":"header-title_title__Fdq1P","telekom_icon":"header-title_telekom_icon__BwV67"};